export var CheckboxGroupOrientations;
(function (CheckboxGroupOrientations) {
    CheckboxGroupOrientations["Vertical"] = "VERTICAL";
    CheckboxGroupOrientations["Horizontal"] = "HORIZONTAL";
})(CheckboxGroupOrientations || (CheckboxGroupOrientations = {}));
